<template>
    <div>
    <header class="bg-[#1a1a1a] text-white shadow sticky top-0 z-50">
        <div class="max-w-7xl mx-auto px-4 py-4 flex justify-between items-center">
            <!-- LOGO -->
            <router-link to="/" class="flex items-center gap-2 cursor-pointer">
                <img src="/brand/getlance-logo.svg" alt="Logo" class="h-20 w-auto" />
            </router-link>

            <!-- NAV DESKTOP -->
            <nav class="hidden md:flex items-center gap-8">
                <router-link to="/projetos" class="hover:text-[#b99a52] transition">Projetos</router-link>
                <router-link to="/buscar-prestadores" class="hover:text-[#b99a52] transition">Presencial</router-link>
                <router-link to="/meus-projetos" class="hover:text-[#b99a52] transition">Meus Projetos</router-link>
                <router-link to="/minhas-propostas" class="hover:text-[#b99a52] transition">Minhas
                    Propostas</router-link>
                <router-link to="/favoritos" class="hover:text-[#b99a52] transition">Favoritos</router-link>
                <router-link to="/perfil" class="hover:text-[#b99a52] transition">Meu Perfil</router-link>
            </nav>

            <!-- AÇÕES -->
            <div class="flex items-center gap-3 md:gap-4">
                <!-- BOTÃO DESTAQUE (CRIAR PROJETO) -->
                <button
                    type="button"
                    @click="handleCreateProjectClick"
                    class="hidden md:inline-block bg-[#b99a52] hover:bg-[#a18446] px-4 py-2 rounded-full font-semibold shadow transition">
                    Criar Projeto
                </button>

                <!-- AVATAR + DROPDOWN (DESKTOP) -->
                <div v-if="user" class="hidden md:block relative" ref="avatarWrapRef">
                    <button type="button"
                        class="w-10 h-10 rounded-full bg-[#374151] hover:bg-[#4b5563] text-white font-semibold text-lg flex items-center justify-center transition focus:outline-none focus:ring-2 focus:ring-white/50 border border-white/20"
                        :title="user?.name || 'Conta'"
                        @click="showDropdown = !showDropdown"
                        aria-haspopup="true"
                        :aria-expanded="showDropdown">
                        {{ avatarLetter }}
                    </button>
                    <div v-if="showDropdown"
                        class="absolute right-0 mt-2 w-52 py-2 bg-white rounded-xl shadow-lg border border-gray-200 text-[#1f2937] z-50">
                        <div class="px-4 py-2 border-b border-gray-100">
                            <p class="text-sm font-medium text-[#152a34] truncate" :title="user?.name">{{ user?.name || 'Usuário' }}</p>
                        </div>
                        <router-link to="/meus-agendamentos" @click="showDropdown = false"
                            class="block px-4 py-2.5 text-sm hover:bg-gray-50 transition">
                            Meus Agendamentos
                        </router-link>
                        <router-link to="/minha-agenda" @click="showDropdown = false"
                            class="block px-4 py-2.5 text-sm hover:bg-gray-50 transition">
                            Minha Agenda
                        </router-link>
                        <router-link to="/meus-servicos" @click="showDropdown = false"
                            class="block px-4 py-2.5 text-sm hover:bg-gray-50 transition">
                            Meus Serviços
                        </router-link>
                        <!--
                            ATENÇÃO: NÃO DESCOMENTAR a não ser que o admin peça de maneira explícita.
                            Os menus "KPIs internos" e "Google Ads (interno)" foram removidos
                            propositalmente. O admin acessa essas telas diretamente pela URL,
                            sem necessidade de menu. Manter comentado.
                        <router-link v-if="canAccessInternalKpis" to="/kpis-internos" @click="showDropdown = false"
                            class="block px-4 py-2.5 text-sm hover:bg-gray-50 transition text-[#b99a52]">
                            KPIs internos
                        </router-link>
                        <router-link v-if="canAccessInternalKpis" to="/google-ads-interno" @click="showDropdown = false"
                            class="block px-4 py-2.5 text-sm hover:bg-gray-50 transition text-[#b99a52]">
                            Google Ads (interno)
                        </router-link>
                        -->
                        <div class="border-t border-gray-100 my-1"></div>
                        <button type="button"
                            class="w-full text-left px-4 py-2.5 text-sm hover:bg-red-50 hover:text-red-700 transition rounded-lg mx-1 mt-0.5"
                            @click="handleLogoutFromDropdown">
                            Sair
                        </button>
                    </div>
                </div>

                <!-- MENU MOBILE (SISTEMA) -->
                <button class="md:hidden text-2xl leading-none" @click="showMenu = true" aria-label="Abrir menu">
                    ☰
                </button>
            </div>
        </div>

        <!-- DRAWER MENU MOBILE -->
        <div v-if="showMenu" class="fixed inset-0 bg-black/40 backdrop-blur-sm z-[999] flex md:hidden">
            <div class="w-80 bg-white h-full p-6 overflow-y-auto relative shadow-xl animate-slideLeft text-[#1f2937]">
                <!-- Botão fechar -->
                <button @click="showMenu = false" class="absolute top-4 right-4 text-gray-500 text-xl"
                    aria-label="Fechar">
                    ✕
                </button>

                <h2 class="text-xl font-semibold mb-6 text-[#152a34]">Menu</h2>

                <div class="space-y-2">
                    <router-link to="/projetos" @click="showMenu = false"
                        class="block px-3 py-2 rounded-xl hover:bg-gray-100 transition">
                        Projetos
                    </router-link>

                    <router-link to="/buscar-prestadores" @click="showMenu = false"
                        class="block px-3 py-2 rounded-xl hover:bg-gray-100 transition">
                        Buscar Prestadores
                    </router-link>

                    <router-link to="/meus-agendamentos" @click="showMenu = false"
                        class="block px-3 py-2 rounded-xl hover:bg-gray-100 transition">
                        Meus Agendamentos
                    </router-link>

                    <router-link to="/minha-agenda" @click="showMenu = false"
                        class="block px-3 py-2 rounded-xl hover:bg-gray-100 transition">
                        Minha Agenda
                    </router-link>

                    <router-link to="/meus-servicos" @click="showMenu = false"
                        class="block px-3 py-2 rounded-xl hover:bg-gray-100 transition">
                        Meus Serviços
                    </router-link>

                    <!--
                        ATENÇÃO: NÃO DESCOMENTAR a não ser que o admin peça de maneira explícita.
                        Os menus "KPIs internos" e "Google Ads (interno)" foram removidos
                        propositalmente. O admin acessa essas telas diretamente pela URL,
                        sem necessidade de menu. Manter comentado.
                    <router-link v-if="canAccessInternalKpis" to="/kpis-internos" @click="showMenu = false"
                        class="block px-3 py-2 rounded-xl hover:bg-gray-100 transition text-[#b99a52] font-medium">
                        KPIs internos
                    </router-link>
                    <router-link v-if="canAccessInternalKpis" to="/google-ads-interno" @click="showMenu = false"
                        class="block px-3 py-2 rounded-xl hover:bg-gray-100 transition text-[#b99a52] font-medium">
                        Google Ads (interno)
                    </router-link>
                    -->

                    <router-link to="/meus-projetos" @click="showMenu = false"
                        class="block px-3 py-2 rounded-xl hover:bg-gray-100 transition">
                        Meus Projetos
                    </router-link>

                    <router-link to="/minhas-propostas" @click="showMenu = false"
                        class="block px-3 py-2 rounded-xl hover:bg-gray-100 transition">
                        Minhas Propostas
                    </router-link>

                    <router-link to="/favoritos" @click="showMenu = false"
                        class="block px-3 py-2 rounded-xl hover:bg-gray-100 transition">
                        Favoritos
                    </router-link>

                    <router-link to="/perfil" @click="showMenu = false"
                        class="block px-3 py-2 rounded-xl hover:bg-gray-100 transition">
                        Meu Perfil
                    </router-link>

                    <div class="my-4 border-t border-gray-200"></div>

                    <!-- CTA Criar Projeto no mobile -->
                    <button
                        type="button"
                        @click="handleCreateProjectClick(true)"
                        class="w-full block text-center bg-[#b99a52] hover:bg-[#a18446] text-white px-4 py-3 rounded-xl font-semibold shadow transition">
                        Criar Projeto
                    </button>

                    <!-- Sair no mobile -->
                    <button @click="handleLogoutFromMenu"
                        class="w-full mt-2 px-4 py-3 rounded-xl border border-red-200 bg-red-50 hover:bg-red-100 text-red-700 font-semibold transition">
                        Sair
                    </button>
                </div>
            </div>

            <!-- clique fora para fechar -->
            <div class="flex-1" @click="showMenu = false"></div>
        </div>
    </header>
    <OnboardingBanner />
    </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import OnboardingBanner from "@/components/OnboardingBanner.vue";
import { logContractorInterest } from "@/services/contractorInterestLog";
import { ALLOWED_INTERNAL_ADMIN_EMAIL } from "@/constants/internalAdmin";

export default {
    name: "AppHeader",

    components: { OnboardingBanner },

    data() {
        return {
            showMenu: false,
            showDropdown: false,
        };
    },

    computed: {
        ...mapGetters(["getUser"]),

        user() {
            return this.getUser || null;
        },

        avatarLetter() {
            const name = this.user?.name;
            if (!name || typeof name !== "string") return "?";
            const first = name.trim().split(/\s+/)[0];
            return (first.charAt(0) || "?").toUpperCase();
        },
        canAccessInternalKpis() {
            const email = String(this.user?.email || "").trim().toLowerCase();
            return email === ALLOWED_INTERNAL_ADMIN_EMAIL;
        },
    },

    methods: {
        ...mapActions(["logout"]),

        handleCreateProjectClick(closeMenu = false) {
            if (this.user) {
                try {
                    logContractorInterest({ type: "remote" });
                } catch (_) {}
            }

            // Evita duplicidade clique(header) + mount(RegisterProject)
            try {
                sessionStorage.setItem("contractorInterest:skipNextRemoteMount", "1");
            } catch (_) {}

            if (closeMenu) this.showMenu = false;
            this.$router.push("/cadastre-seu-projeto");
        },

        handleLogout() {
            this.logout();
            if (this.$route.path !== "/") {
                this.$router.push("/");
            }
        },

        handleLogoutFromDropdown() {
            this.showDropdown = false;
            this.handleLogout();
        },

        handleLogoutFromMenu() {
            this.showMenu = false;
            this.handleLogout();
        },

        onDocumentClick(e) {
            if (this.$refs.avatarWrapRef && !this.$refs.avatarWrapRef.contains(e.target)) {
                this.showDropdown = false;
            }
        },
    },

    mounted() {
        document.addEventListener("click", this.onDocumentClick);
    },

    beforeUnmount() {
        document.removeEventListener("click", this.onDocumentClick);
    },
};
</script>

<style scoped>
@keyframes slideLeft {
    from {
        transform: translateX(-100%);
    }

    to {
        transform: translateX(0);
    }
}

.animate-slideLeft {
    animation: slideLeft 0.25s ease-out;
}
</style>
